import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CmxHttpClient } from '@cemex/cmx-client-layout';
import { select, Store } from '@ngrx/store';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { IJobsiteSalesAreaResponse } from '../../models/order-management/jobsite-sales-area.model';
import { getLocationJobsiteState } from '@ordersnproducts/modules/order-builder/reducers/index';
import { LocationSpecificationFormState } from '../../reducers/location-specification.reducer';

@Injectable()
export class JobsiteLoaderService implements SelectOptionLoaderI {
  constructor(
    private store: Store<LocationSpecificationFormState>,
    private http: CmxHttpClient,
  ) {}

  public getJobsiteSalesAreas(
    productLineId: number | string,
    shipmentlocationId: number | string,
  ): Observable<IJobsiteSalesAreaResponse> {
    const endpoint = `/v8/sm/jobsitesalesareas?productlineId=${productLineId}&shipmentlocationId=${shipmentlocationId}.2`;
    return this.http.get<IJobsiteSalesAreaResponse>(endpoint);
  }

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getLocationJobsiteState),
      filter((jobsitesState) => !!jobsitesState.jobsites),
      map((jobsitesState) => {
        const result = jobsitesState.jobsites.map((jobsite) => {
          return {
            id: jobsite.jobsiteId,
            name: `${jobsite.jobsiteCode.replace(/0+/, '')} ${jobsite.jobsiteDesc}`,
            default: jobsitesState.selected && jobsitesState.selected.jobsiteId === jobsite.jobsiteId,
          };
        });

        return result;
      }),
    );
  }
}
